<template>
  <ChecklistItem
    title="5. Apply to collaborate"
    description="Find other creators to team up with"
    :is-done="false"
    :editing="false"
  >
    <template #pitch>
      <iText font-size="standard">
        Coming soon...
      </iText>
    </template>
  </ChecklistItem>
</template>

<script>
import ChecklistItem from "@/components/onboarding/ChecklistItem.vue";
export default { name: "CollaborationChecklist", components: { ChecklistItem } };
</script>

<style scoped lang="scss">
</style>
